import { createRecipe } from './runtime.js';

const iconButtonBaseConfig = {"name":"iconButtonBase","defaultVariants":{"size":"md"},"variantMap":{"size":["lg","md","sm","xl","xs"]}}

export const iconButtonBase = /* @__PURE__ */ createRecipe(iconButtonBaseConfig)